<template>
  <div class="c-review-selections l-flex">
    <div class="c-review-selections__wrapper l-flex l-flex--column">
      <h1
        ref="headingToFocus"
        class="c-review-selections__title t-heading-5 u-margin-bottom-small"
        tabindex="0"
      >
        {{ step.personalizationTitle }}
      </h1>
      <template v-if="!starWarsType">
        <div
          v-for="(item, index) of items"
          :key="index"
          class="c-review-selections__item-wrapper l-flex l-flex--column"
        >
          <hr>
          <div
            class="c-review-selections__item-container l-flex l-flex--justify-between"
          >
            <div
              v-if="item.name == 'band' || 'clasp' && item.name != 'sleeve'"
              class="c-review-selections__review-item"
            >
              <h2 class="c-review-selections__item-title t-heading-6">
                {{ item.name }}
              </h2>
              <p
                v-if="item.color"
                class="t-paragraph-small u-margin-bottom-none"
              >
                {{ item.color }}
              </p>
              <p
                v-if="item.sizeOrFinish"
                class="t-paragraph-small u-margin-bottom-none"
              >
                {{ item.sizeOrFinish }}
              </p>
              <item-props
                :item="item"
                :line-item-props="lineItemProps"
              />
            </div>
            <div v-else>
              <div class="l-flex l-flex--justify-start">
                <h2 class="c-review-selections__item-title c-review-selections__item-title--sleeve t-heading-6">
                  {{ item.name }}
                </h2>
                <span
                  v-if="sleeveSelection"
                  class="c-review-selections__fees t-heading-10"
                >
                  +${{ sleevePrice }}
                </span>
              </div>
              <div v-if="sleeveSelection">
                <p
                  v-if="item.color"
                  class="t-paragraph-small u-margin-bottom-none"
                >
                  {{ item.color }}
                </p>
                <p
                  v-if="item.sizeOrFinish"
                  class="t-paragraph-small u-margin-bottom-none"
                >
                  {{ item.sizeOrFinish }}
                </p>
                <item-props
                  :item="item"
                  :line-item-props="lineItemProps"
                />
              </div>
              <div v-if="!sleeveSelection">
                <h3 class="t-paragraph-small">
                  None
                </h3>
              </div>
            </div>
            <btn
              class="t-link"
              type="link"
              url="#"
              @click="jumpToStep(item.name)"
            >
              EDIT {{ item.name.toUpperCase() }}
            </btn>
          </div>
        </div>
      </template>
      <template v-if="starWarsType">
        <div
          v-for="(item, index) of items"
          :key="index"
          class="c-review-selections__item-wrapper l-flex l-flex--column"
        >
          <hr v-if="item.name != 'sleeve'">
          <div
            class="c-review-selections__item-container l-flex l-flex--justify-between"
          >
            <div
              v-if="item.name == 'band' || 'clasp' && item.name != 'sleeve'"
              class="c-review-selections__review-item"
            >
              <h2 class="c-review-selections__item-title t-heading-6">
                {{ item.name }} {{ item.name == 'clasp' ? 'and sleeve' : '' }}
              </h2>
              <p
                v-if="item.color"
                class="t-paragraph-small u-margin-bottom-none"
              >
                {{ item.color }}
              </p>
              <p
                v-if="item.sizeOrFinish"
                class="t-paragraph-small u-margin-bottom-none"
              >
                {{ item.sizeOrFinish }}
              </p>
              <item-props
                :item="item"
                :line-item-props="lineItemProps"
              />
            </div>
            <div v-else-if="item.name != 'sleeve'">
              <div class="l-flex l-flex--justify-start">
                <h2 class="c-review-selections__item-title c-review-selections__item-title--sleeve t-heading-6">
                  {{ item.name }}
                </h2>
                <span
                  v-if="sleeveSelection"
                  class="c-review-selections__fees t-heading-10"
                >
                  +${{ sleevePrice }}
                </span>
              </div>
              <div v-if="sleeveSelection">
                <p
                  v-if="item.color"
                  class="t-paragraph-small u-margin-bottom-none"
                >
                  {{ item.color }}
                </p>
                <p
                  v-if="item.sizeOrFinish"
                  class="t-paragraph-small u-margin-bottom-none"
                >
                  {{ item.sizeOrFinish }}
                </p>
                <item-props
                  :item="item"
                  :line-item-props="lineItemProps"
                />
              </div>
              <div v-if="!sleeveSelection">
                <h3 class="t-paragraph-small">
                  None
                </h3>
              </div>
            </div>
            <btn
              v-if="item.name != 'sleeve' && item.name != 'clasp'"
              class="t-link"
              type="link"
              url="#"
              @click="jumpToStep(item.name)"
            >
              EDIT {{ item.name.toUpperCase() }}
            </btn>
          </div>
        </div>
      </template>
      <hr>
      <div class="c-review-selections__subtotal l-flex l-flex--justify-between l-flex-align-between u-margin-bottom-large">
        <h2 class="c-review-selections__subtotal-amount t-heading-6">
          Subtotal
        </h2>
        <p class="c-review-selections__subtotal-amount t-heading-6">
          <product-price
            :price="subtotal | currency"
            :compare-at-price="compareAtSubtotal | currency"
          />
        </p>
      </div>
      <btn
        v-if="!starWarsType"
        class="c-review-selections__engraving-btn"
        type="primary-open"
        :class="[
          't-paragraph-small',
          'u-margin-bottom-x-small'
        ]"
        @click="addEngraving"
      >
        {{ addEngravingLabel }}
      </btn>
      <btn
        class="c-review-selections__add-to-cart t-paragraph-small u-margin-bottom-x-small"
        aria-label="Add custom bracelet to cart and leave the bracelet builder."
        @click="handleAddToCart"
      >
        ADD TO CART -
        <product-price
          :price="subtotal | currency"
        />
      </btn>
      <btn
        type="link"
        url="#"
        @click="decrementStep"
      >
        BACK
      </btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex"
import Btn from "@/components/button/Btn";
import ItemProps from './ReviewSelectionsItemProps'
import ProductPrice from "@/components/productPrice/ProductPrice";
export default {
  name: "ReviewSelections",
  filters: {
    engraving: (value) => `Engraving ${value}`.toUpperCase()
  },
  components: {
    ProductPrice,
    Btn,
    ItemProps
  },
  props: {
    step: {
      type: Object,
      default: null
    },
    completionRedirect: {
      type: String,
      default: null
    },
    selections: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('braceletBuilder', [
      'bracelets',
      'currentStep',
      'fees',
      'lineItemProps',
      'starWarsType'
    ]),
    ...mapGetters('braceletBuilder', [
      'loading',
      'nextStep',
      'bandColor',
      'claspColor',
      'claspFinish',
      'subtotal',
      'compareAtSubtotal',
      'engravingFee',
      'sleeveFee'
    ]),
    addEngravingLabel() {
      const engravingPrice = this.engravingPrice
      const hasEngraving = this.lineItemProps && (this.lineItemProps.length > 0)
      return (hasEngraving)
        ? 'Edit Engraving'
        : `Add Engraving - $${engravingPrice}`
    },
    items() {
      let items = [
        {
          name: 'band',
          color: `COLOR: ${this.bandColor}`,
          sizeOrFinish: `SIZE: ${this.selections.size}`
        },
        {
          name: 'clasp',
          color: `COLOR: ${this.claspColor}`,
          sizeOrFinish: `FINISH: ${this.claspFinish}`
        },
        {
          name: 'sleeve',
          color: `COLOR: ${this.claspColor}`,
          sizeOrFinish: `FINISH: ${this.claspFinish}`
        }
      ]
      return items
    },
    sleeveSelection() {
      return this.selections.sleeve ? true : false
    },
    sleevePrice() {
      return parseFloat(this.sleeveFee.price).toFixed(2)
    },
    engravingPrice() {
      return this.engravingFee.price
    }
  },
  mounted() {
    const headingToFocus = this.$refs.headingToFocus;
    if (headingToFocus) {
      this.$refs.headingToFocus.focus();
    }
  },
  methods: {
    ...mapMutations('cart', ['showCart']),
    ...mapMutations('braceletBuilder', [
      'update'
    ]),
    ...mapActions('braceletBuilder', [
      'incrementStep',
      'decrementStep',
      'jumpToStep',
      'addToCart',
      'addEngraving'
    ]),
    async handleAddToCart() {
      const nextUrl = this.completionRedirect
      await this.addToCart()
      console.log('[ReviewSelections] next=', nextUrl)
      if (nextUrl) {
        this.$router.push(nextUrl || '/collections/bracelets')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-review-selections {
  margin-top: rem(20px);
  &__item-wrapper {
    width: 100%;
  }
  &__item-container {
    width: 100%;
  }
  &__item-title {
    text-transform: uppercase;
  }
  &__item-title--sleeve {
    margin-right: rem(5px);
  }
  hr {
    width: 100%;
    margin: rem(10px) 0;
    border: 0;
    border-top-color: currentcolor;
    border-top-style: none;
    border-top-width: 0px;
    @include themify($themes) {
      border-top: 1px solid themed('foreground', 'strikeout');
    }
  }
  &__fees {
    @include themify($themes) {
      color: themed('foreground', 'strikeout');
    }
  }
  &__subtotal {
    width: 100%;
  }
  &__engraving-btn {
    width: 100%;
  }
  &__add-to-cart {
    width: 100%;
  }
}
</style>
